import Component, {
  categoryMetaData,
} from "~/route-containers/partner/category.container";
import { productsLoader } from "~/loaders/products.loader";

export { categoryMetaData as meta };
export { productsLoader as loader };
export default Component;
